module.exports = __webpack_public_path__ + "img/icon-camera.77344afa.svg";